/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import {
  get as getAxios,
  post as postAxios,
  put as putAxios,
  deleteCall as deleteAxios,
} from "../apiHandler";

const endPoint = process.env.REACT_APP_API_BASE_URL;
const PAGE_SIZE = 10;

const get = (url, { data, accessToken }) =>
  getAxios(url, { data, accessToken, endPoint });
const post = (url, { accessToken, data, params }) =>
  postAxios(url, { accessToken, data, endPoint, params });
const put = (url, { accessToken, data, params }) =>
  putAxios(url, { accessToken, data, endPoint, params });
const deleteCall = (url, { accessToken, data, params }) =>
  deleteAxios(url, { accessToken, data, endPoint, params });

export default class Examination {
  static MemberSearch(data, params) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(
      `/api/reports/examination/eligible/search?page=${params.page}&size=${params.pageSize}`,
      {
        accessToken: accessTokenFromLocal,
        data,
        params: {
          size: PAGE_SIZE,
          page: params.page,
        },
      }
    );

    Examination.MemberSearch.cancel = request.cancel;
    return request;
  }

  static eligibleMemberReport({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/reports/examination/eligible/download`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Examination.eligibleMemberReport.cancel = request.cancel;
    return request;
  }

  static AppliedMemberSearch(data, params) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(
      `/api/reports/examination/applied/search?page=${params.page}&size=${params.pageSize}`,
      {
        accessToken: accessTokenFromLocal,
        data,
        params: {
          size: PAGE_SIZE,
          page: params.page,
        },
      }
    );

    Examination.AppliedMemberSearch.cancel = request.cancel;
    return request;
  }

  static ResultMemberSearch(data, params) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(
      `/api/reports/examination/result/search?page=${params.page}&size=${params.pageSize}`,
      {
        accessToken: accessTokenFromLocal,
        data,
        params: {
          size: PAGE_SIZE,
          page: params.page,
        },
      }
    );

    Examination.AppliedMemberSearch.cancel = request.cancel;
    return request;
  }

  static appliedMemberReport({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/reports/examination/applied/download`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Examination.appliedMemberReport.cancel = request.cancel;
    return request;
  }

  static resultMemberReport({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/reports/examination/result/download`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Examination.resultMemberReport.cancel = request.cancel;
    return request;
  }

  static deactivateAppliedMember({ data, applicationId }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/examinations/applications/${applicationId}/deactivate`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Examination.deactivateAppliedMember.cancel = request.cancel;
    return request;
  }

  static ExamDirectEntry(data, memberId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/members/${memberId}/examination/applications`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Examination.ExamDirectEntry.cancel = request.cancel;
    return request;
  }
}
